import React from 'react';

const HowItWorksSection: React.FC = () => {
  const steps = [
    { step: '1', title: 'Search & Select', desc: 'Find the service and provider that fits your needs' },
    { step: '2', title: 'Pick a Time', desc: 'Choose from available slots that work for your schedule' },
    { step: '3', title: 'Book & Confirm', desc: 'Complete your booking and get instant confirmation' },
  ];

  return (
    <section className="py-10 sm:py-16 px-3 xs:px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-primary-600 to-accent-600 text-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-2xl xs:text-3xl sm:text-4xl font-bold mb-2 sm:mb-4">
            How It Works
          </h2>
          <p className="text-base sm:text-xl text-white/90">
            Book your appointment in 3 simple steps
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
          {steps.map((item, index) => (
            <div key={index} className="relative">
              <div className="bg-white/10 min-h-[213px] backdrop-blur-sm rounded-xl sm:rounded-2xl p-4 sm:p-6 border border-white/20">
                <div className="w-12 h-12 sm:w-16 sm:h-16 bg-white text-primary-600 rounded-full flex items-center justify-center text-xl sm:text-2xl font-bold mb-3 sm:mb-4">
                  {item.step}
                </div>
                <h3 className="text-lg sm:text-xl font-bold mb-1 sm:mb-2">{item.title}</h3>
                <p className="text-sm sm:text-base text-white/90">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
